import './CustomExpander.scss';

const CustomExpander: React.FC<{ isExpanded: boolean }> = ({ isExpanded }) => (
  <div className="expander">
    <div className={`expander-icon  ${isExpanded ? 'expanded' : ''}`}>{isExpanded ? '-' : '+'}</div>
  </div>
);

export default CustomExpander;
